import { render, staticRenderFns } from "./ClinicTreatments.vue?vue&type=template&id=556ce062"
import script from "./ClinicTreatments.vue?vue&type=script&lang=js"
export * from "./ClinicTreatments.vue?vue&type=script&lang=js"
import style0 from "./ClinicTreatments.vue?vue&type=style&index=0&id=556ce062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports